export const makeEventDetailsQueryKey = (id: string) => ['event-details', id];